<template>
  <div>
    <div class="breadcrumb">订单辅助查询</div>
    <div>
      <el-form ref="form" label-width="150px" style="margin:50px 30px">
        <el-form-item label="第三方订单号" v-if="$hasPermission('oms:admin:otherOrder:check')">
          <el-input v-model="thirdOrder" clearable style="width: 300px;"></el-input>
          <el-button type="primary" @click="checkThirdOrder">查询</el-button>
        </el-form-item>
        <el-form-item label="订单号" v-if="$hasPermission('oms:admin:otherOrder:check')"> {{ orderId }} </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { getByOutOrderNo } from '@/api/oms.js'
export default {
  data () {
    return {
      thirdOrder: '',
      orderId: ''
    }
  },
  methods: {
    checkThirdOrder () {
      if (!this.thirdOrder) {
        this.$message.error('请输入订单号')
        return
      }
      getByOutOrderNo(this.thirdOrder).then(res => {
        if (res.data.success && res.data.data) {
          this.$message.success('查询成功')
          this.orderId = res.data.data
        } else {
          this.$message.error('订单不存在')
        }
      })
    }
  }
}
</script>
<style></style>
